import React from 'react';

const Button = ({ children, variant = 'primary', onClick, className = '', style = {}, type = 'button', disabled = false, fullWidth = false, size = 'md', ...props }) => {
    const sizeMap = {
        sm: { padding: '8px 20px', fontSize: '13px' },
        md: { padding: '12px 28px', fontSize: '14px' },
        lg: { padding: '16px 36px', fontSize: '15px' },
    };

    const baseStyle = {
        fontFamily: "'Vollkorn', Georgia, serif",
        fontSize: sizeMap[size].fontSize,
        fontWeight: 600,
        letterSpacing: '1px',
        padding: sizeMap[size].padding,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        border: 'none',
        textDecoration: 'none',
        opacity: disabled ? 0.5 : 1,
        width: fullWidth ? '100%' : 'auto',
    };

    const variants = {
        primary: {
            backgroundColor: '#7C2D12',
            color: '#FAF3EB',
            border: '1px solid #7C2D12',
        },
        vintage: {
            backgroundColor: '#A0845C',
            color: '#FAF3EB',
            border: '1px solid #A0845C',
        },
        secondary: {
            backgroundColor: 'transparent',
            color: '#7C2D12',
            border: '1px solid #7C2D12',
        },
        ghost: {
            backgroundColor: 'transparent',
            color: '#7C2D12',
            border: '1px solid transparent',
        },
    };

    const hoverColors = {
        primary: { bg: '#6B2410', color: '#FAF3EB', border: '#6B2410' },
        vintage: { bg: '#8B7350', color: '#FAF3EB', border: '#8B7350' },
        secondary: { bg: '#7C2D12', color: '#FAF3EB', border: '#7C2D12' },
        ghost: { bg: 'rgba(124,45,18,0.05)', color: '#6B2410', border: 'transparent' },
    };

    const mergedStyle = { ...baseStyle, ...variants[variant], ...style };

    return (
        <button
            type={type}
            onClick={onClick}
            className={className}
            disabled={disabled}
            style={mergedStyle}
            onMouseEnter={(e) => {
                if (disabled) return;
                const h = hoverColors[variant];
                e.currentTarget.style.backgroundColor = h.bg;
                e.currentTarget.style.color = h.color;
                e.currentTarget.style.borderColor = h.border;
            }}
            onMouseLeave={(e) => {
                if (disabled) return;
                const v = variants[variant];
                e.currentTarget.style.backgroundColor = v.backgroundColor;
                e.currentTarget.style.color = v.color;
                e.currentTarget.style.borderColor = v.border.replace('1px solid ', '');
            }}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
